import { InsightData } from 'schemas/action/InsightDataSchema'

const stripData = (innerDataSet: InsightData[], insight: string) =>
  innerDataSet.filter((levelOneData) => levelOneData.name !== insight)

export default stripData
